var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"single-modal"},[_c('h3',[_vm._v("Invest in JCI through the JCI Foundation.")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.introduce)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }